import AddIcon from "@mui/icons-material/Add";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import { Box, Button, Container, TextField, Typography } from "@mui/material";
import { DataGrid, GridRowSelectionModel } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import ConfirmationDialog from "../../components/dialog/simple-alert";
import DialogQuestionnaire from "../../components/dialogquestionnaire/dialog-questionnaire";
import Loading from "../../components/loading/loading";
import { useProfileColumns } from "../../hooks/use-profile-columns/context";
import { homeStyle } from "../../styles/container/home";
import useViewModel from "./ViewModel";

function HomePageRevamped() {
  const {
    data: { listTrRequest, loadingActive },
    method: { onGetTopTenListTrData, onDeleteSelected },
  } = useViewModel();

  const { columns: columnsToUse } = useProfileColumns();
  const [isDialogOpenConfirmation, setIsDialogOpenConfirmation] =
    useState(false);
  const [searchText, setSearchText] = useState("");
  const [selectedRows, setSelectedRows] = useState<GridRowSelectionModel>([]);

  useEffect(() => {
    onGetTopTenListTrData();
  }, []);

  const handleSearchOnClick = () => {
    onGetTopTenListTrData(searchText);
  };

  return (
    <Container maxWidth={false} disableGutters sx={homeStyle.containerStyling}>
      <Box sx={{ fontSize: "25px" }} className="black">
        Home
        <hr />
      </Box>
      <br />

      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: "10px",
        }}
      >
        <Typography sx={{ fontSize: "20px" }} className="black">
          Top 10 List of Request
        </Typography>
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          marginBottom: "10px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Link to="/form">
            <Button variant="contained" sx={{ textTransform: "none" }}>
              <AddIcon /> Add New Request
            </Button>
          </Link>
          <div className="searchDataTable">
            <TextField
              placeholder="Search"
              variant="outlined"
              onChange={(e) => setSearchText(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSearchOnClick();
                }
              }}
            />
            <Button
              onClick={handleSearchOnClick}
              style={{ padding: 0, minWidth: "40px" }}
            >
              <SearchOutlinedIcon className="black" />
            </Button>
          </div>
        </Box>
      </Box>

      {selectedRows.length > 0 && (
        <Button
          variant="contained"
          sx={homeStyle.buttonDeleteStyle}
          onClick={() => setIsDialogOpenConfirmation(true)}
        >
          <span> </span>
          <DeleteOutlinedIcon />
        </Button>
      )}

      <div style={{ width: "100%", backgroundColor: "white" }}>
        <DataGrid
          rows={listTrRequest || []}
          columns={columnsToUse}
          initialState={{
            pagination: {
              paginationModel: { page: 0, pageSize: 10 },
            },
          }}
          getRowId={(row) => row.requestID}
          pageSizeOptions={[10]}
          checkboxSelection
          onRowSelectionModelChange={(row) => setSelectedRows(row)}
          isRowSelectable={(params) => params.row.requestNumber === "-"}
          autoHeight
          getRowHeight={() => "auto"}
        />
      </div>

      <ConfirmationDialog
        open={isDialogOpenConfirmation}
        title="Confirmation Title"
        message="Are you sure you want to proceed?"
        onConfirm={() => {
          onDeleteSelected(selectedRows);
          setIsDialogOpenConfirmation(false);
        }}
        onCancel={() => {
          setIsDialogOpenConfirmation(false);
        }}
      />

      <DialogQuestionnaire open={false} />

      <Loading open={loadingActive} />
    </Container>
  );
}

export default HomePageRevamped;
